import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Chart } from 'chart.js';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';
import { LineCharData } from 'src/app/modules/dashboard/utils/line_chart_data';

@Component({
  selector: 'general-report-resume',
  templateUrl: './general-report-resume.component.html',
  styleUrls: ['./general-report-resume.component.scss'],
})
export class GeneralReportResumeComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private resumeService: ResumeService) {}

  ngOnInit() {
    this.resumeService.filterResumeReport.subscribe({
      next: (filters: any) => {
        for (let key in filters) {
          if (
            filters[key] == '' ||
            filters[key] == 'null' ||
            filters[key] == null
          ) {
            delete filters[`${key}`];
          }
        }

        this.getData(filters);
      },
    });
    this.getData();
  }
  data;
  dataSource;
  displayedColumns: string[] = [];

  setData(data: []) {
    this.data = data;
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
  }
  res;
  getData(filters = {}) {
    this.resumeService.generalReportResumen(filters).subscribe((res: any) => {
      this.res = res;
      this.displayedColumns = res.labelsUnitTable;
      this.setData(res.table);
      this.generalStatus(res.casesByUnitStatus);
      this.general(res.casesByUnit);
    });
  }
  bar: Chart;
  general(data) {
    if (this.bar) {
      this.bar.destroy();
    }
    var canvas = document.getElementById(
      'GeneralReportResume'
    ) as HTMLCanvasElement;
    var parent = document.getElementById('contentGeneralReportResume');

    // canvas.width = parent.offsetWidth;
    this.bar = new Chart('GeneralReportResume', {
      type: 'bar',
      data: {
        labels: data.labels,

        datasets: [
          {
            data: data.countCases,
            backgroundColor: [
              '#005dd0',
              '#2e8cef',
              '#30c5ff',
              '#f6a506',
              '#f58500',
              '#ff5733',
              '#ff0055',
            ],
          },
        ],
      },
      options: {
        // indexAxis: 'y',
        elements: {
          // bar: {
          //   borderWidth: 2,
          // }
        },
        responsive: true,

        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var value =
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return value.toString();
            },
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
    });
  }
  barStatus: Chart;
  generalStatus(data: any) {
    if (this.barStatus) {
      this.barStatus.destroy();
    }
    var canvas = document.getElementById(
      'GeneralReportResumeStatus'
    ) as HTMLCanvasElement;
    var parent = document.getElementById('contentGeneralReportResumeStatus');

    // canvas.width = parent.offsetWidth;
    this.barStatus = new Chart('GeneralReportResumeStatus', {
      type: 'bar',
      data: {
        labels: data.labels,

        datasets: data.data,
      },
      options: {
        // indexAxis: 'y',
        elements: {
          // bar: {
          //   borderWidth: 2,
          // }
        },
        responsive: true,

        legend: {
          display: true,
          position: 'bottom',
        },
        // tooltips: {
        //   callbacks: {
        //     label: function (tooltipItem, data) {
        //       var value =
        //         data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        //       return value.toString();
        //     },
        //   },
        // },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
    });
  }
}
